import React from 'react';
import { FontAwesome } from '@expo/vector-icons';
import { themePattern } from '../../constants/pattern';
import { StyleSheet, Text, View, TouchableOpacity, Button, Dimensions } from 'react-native';
import { PropsButtuns } from '../../types';

const { width, height } = Dimensions.get('window')


function BtnRectangle(props: PropsButtuns) {

  // Função ancora
  let onPress = () => {
    props.onPress();
  };

  return (
    
      <TouchableOpacity
        onPress={() => onPress()}
        
      >
        <View style={styles.BtnRectangle}>
          <View style={styles.iconContainer}>
            <View style={styles.icon}>
              <FontAwesome

                name={props.icon}
                style={
                  styles.iconFont
                }

              />
            </View>
          </View>
          <View style={styles.containerTitle}>
            <Text style={styles.title}>{props.name}</Text>

          </View>
        </View>
      </TouchableOpacity>


  );
}




function Styles() {

  //Mobile
  if (themePattern.breakpoint.mobile >= width)
      return StyleSheet.create({
        BtnRectangle: {
          height: 56,
          width: 'auto',
          justifyContent: 'center',
          flexDirection: 'row',
          alignItems: "center",
        },
        icon: {
          width: "100%",
          height: "100%",
      
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
      
      
      
      
          alignItems: "center",
      
        },
        iconFont: {
          color: themePattern.mobile.white,
          fontSize: 24
        },
        iconContainer: {
          marginRight: 5,
          backgroundColor: themePattern.mobile.color1,
          color: themePattern.mobile.white,
          width: 56,
          height: 56,
          borderRadius: 10,
          elevation: 4,
          shadowColor: 'black',
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.25,
          shadowRadius: 4,
      
        },
        containerTitle: {
          marginLeft: 5,
          borderColor: themePattern.mobile.color1,
          borderWidth: 2,
          borderRadius: 10,
          width: 200,
          height: 56,
          alignItems: 'center',
          justifyContent: 'center'
      
        }
        , title: {
          fontSize: themePattern.mobile.title3,
          color: themePattern.mobile.color1
      
        }
      });

  //Tablet
  else
      return StyleSheet.create({
        BtnRectangle: {
          height: 70,
          width: 'auto',
          justifyContent: 'center',
          flexDirection: 'row',
          alignItems: "center",
        },
        icon: {
          width: "100%",
          height: "100%",
      
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
      
      
      
      
          alignItems: "center",
      
        },
        iconFont: {
          color: themePattern.mobile.white,
          fontSize: 24
        },
        iconContainer: {
          marginRight: 5,
          backgroundColor: themePattern.mobile.color1,
          color: themePattern.mobile.white,
          width: 70,
          height: 70,
          borderRadius: 10,
          elevation: 4,
          shadowColor: 'black',
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.25,
          shadowRadius: 4,
      
        },
        containerTitle: {
          marginLeft: 5,
          borderColor: themePattern.mobile.color1,
          borderWidth: 2,
          borderRadius: 10,
          width: 400,
          height: 70,
          alignItems: 'center',
          justifyContent: 'center'
      
        }
        , title: {
          fontSize: themePattern.mobile.title3,
          color: themePattern.mobile.color1
      
        }
      });
}

const styles = Styles()

export default BtnRectangle;